/**
  * @author Vinny DeFrancesco, Ryan Gladstone, Brendan Magee
  */

function storiesService(
  $http,
  $q,
  $translate,
  _,
  analyticsService,
  collectionsService
) {
  const service = {};

  service.getStories = async (params) => {
    try {
      const { data } = await $http.get('/editorial-search/websked-search', {
        params
      });

      if (data && Array.isArray(data.results)) {
        const stories = await collectionsService.addUsagesToStories(data.results);

        return { ...data, results: stories };
      }

      return data;
    } catch (error) {
      return error;
    }
  };

  service.getStory = (id) => {
    const deferred = $q.defer();

    if (id === null || id === undefined) {
      deferred.reject($translate.instant('PLEASE_PROVIDE_STORY_ID'));
    } else {
      $http({
        method: 'GET',
        url: 'api/stories',
        params: {
          id
        }
      })
        .success((storyData) => {
          const data = storyData;
          deferred.resolve(data);
        })
        .error((data) => {
          deferred.reject(data);
        });
    } // else

    return deferred.promise;
  };

  service.getPublishedStoryCount = async (startDate, endDate, sections, platforms) => {
    const searchParams = {
      size: 1,
      sections,
      platforms,
      page: 0,
      sort: 'time',
      startDate,
      endDate,
      publishStatus: 3
    };

    return $http({
      method: 'GET',
      url: '/editorial-search/websked-search',
      params: searchParams
    });
  };

  service.updateStory = (updateObj) => {
    /* tell the dev not to use the method improperly */

    if (typeof updateObj !== 'object') {
      throw new Error('updateStory should be called with a config object');
    }

    if (!updateObj.id) {
      throw new Error('you tried to update a story, but you didn\'t provide a story id');
    }

    const deferred = $q.defer();

    $http.put('api/stories', updateObj)
      .then((response) => {
        // Currently, the updateStory method is only used for updating the note.
        // If it is ever updated to handle skedlines, for example, this tracking
        // note should be updated to be more general
        analyticsService.trackEvent('Story management', 'Updated story note');
        deferred.resolve(response);
      }, (response) => {
        deferred.reject(response);
      });

    return deferred.promise;
  };
  return service;
}

const arr = [
  '$http',
  '$q',
  '$translate',
  '_',
  'analyticsService',
  'collectionsService',
  storiesService
];

export default function (ngModule) {
  ngModule.service('storiesService', arr);
}
